import request from './'

export const getAvailabilities = ({ ids, startsAt, stopsAt, startLocationId }) => {
  return request({
    method: 'POST',
    url: '/api/boomerang/availabilities',
    data: {
      filter: {
        item_id: ids,
        from: startsAt,
        till: stopsAt,
        location_id: startLocationId
      }
    }
  })
}

export const getAvailability = ({ id, startsAt, stopsAt, startLocationId, configuration }) => {
  return request({
    method: 'POST',
    url: '/api/boomerang/availabilities',
    data: {
      filter: {
        item_id: id,
        from: startsAt,
        till: stopsAt,
        location_id: startLocationId,
        configuration
      }
    }
  })
}
